"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _store = _interopRequireDefault(require("./../store/store"));

var _PulseWidget = _interopRequireDefault(require("./../components/flyouts/PulseWidget"));

var _reactRedux = require("react-redux");

var _Card = _interopRequireDefault(require("./../components/card/Card"));

var _Provider = _interopRequireDefault(require("@react/react-spectrum/Provider"));

var _Popover = _interopRequireDefault(require("@react/react-spectrum/Popover"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Since the parent element of this Component is outside the hierarchy of
 * React Elements, so need to wrapped with the required providers here.
 *
 * @param props
 * @class
 */
var PulseWidgetWrapper = function PulseWidgetWrapper(props) {
  var closeMenu = props.closeMenu,
      onViewAllClicked = props.onViewAllClicked;

  var onPulseViewAll = function onPulseViewAll(activeTab) {
    onViewAllClicked(activeTab);
    closeMenu && closeMenu();
  };

  var onPulsePreferences = function onPulsePreferences() {
    closeMenu && closeMenu();
  };

  return _react.default.createElement(_Popover.default, (0, _extends2.default)({
    className: "pulse-popover",
    isDialog: false,
    role: "dialog"
  }, props, {
    style: _objectSpread({}, props.style, {
      backgroundColor: 'transparent',
      top: 40
    })
  }), _react.default.createElement(_Card.default, null, _react.default.createElement(_Provider.default, {
    className: "pulse-card-provider"
  }, _react.default.createElement(_reactRedux.Provider, {
    store: _store.default
  }, _react.default.createElement(_PulseWidget.default, {
    onPreferencesClicked: onPulsePreferences,
    onViewAllClicked: function onViewAllClicked(tab) {
      return onPulseViewAll(tab);
    }
  })))));
};

var _default = PulseWidgetWrapper;
exports.default = _default;